import api from '../../../api/index';

export default {
    getMe: (_) => api.get('webservice/editor/get-me'),
}